import * as React from 'react';
import { noop } from 'vet-bones/utils';

export enum AddModelType {
  IMPORT = 'IMPORT',
  LOCAL = 'LOCAL',
  UPLOAD = 'UPLOAD',
}

type AddModelTypeContextValue = {
  addModelType: AddModelType | null;
  setAddModelType: (type: AddModelType | null) => void;
};

export const AddModelTypeContext =
  React.createContext<AddModelTypeContextValue>({
    addModelType: null,
    setAddModelType: noop,
  });

export const useAddModelType = () => {
  return React.useContext(AddModelTypeContext);
};

export const useAddModelTypeValue = (): AddModelTypeContextValue => {
  const [addModelType, setAddModelType] = React.useState<AddModelType | null>(
    null
  );
  return { addModelType, setAddModelType };
};
